export enum RotasEnum {
  DADOS_PESSOAIS = <any>'dados-pessoais',
  ENDERECO = <any>'endereco',
  PAGAMENTO = <any>'pagamento',
  CHECKOUT = <any>'checkout',
  CONFIRMACAO = <any>'confirmacao'
}
